// src/components/SeoMeta.js - Simple version without react-helmet-async
import React, { useEffect } from 'react';

const SeoMeta = () => {
  useEffect(() => {
    // Update document title
    document.title = "KyroTech - Digital Agency & Software Solutions";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "KyroTech transforms ideas into digital reality. We create exceptional digital experiences that drive business growth.";
    
    // Update other meta tags
    const metaTags = {
      'keywords': 'digital agency, software development, web design, mobile apps, digital marketing',
      'author': 'KyroTech',
      'og:title': 'KyroTech - Digital Agency & Software Solutions',
      'og:description': 'Professional digital solutions for your business growth.',
      'og:type': 'website',
      'og:url': window.location.href,
      'twitter:card': 'summary_large_image',
      'twitter:title': 'KyroTech - Digital Agency',
      'twitter:description': 'Professional digital solutions for your business growth.'
    };
    
    Object.entries(metaTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`) || 
                 document.querySelector(`meta[property="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    
    // Cleanup on unmount
    return () => {
      document.title = ''; // Reset to default or keep as is
    };
  }, []);

  return null; // This component doesn't render anything
};

export default SeoMeta;